import { string } from 'yup'

export const validateEmail = string()
  .required('Email is required')
  .email('Email is invalid')
  .min(6, 'Email must be 6 to 254 characters long')
  .max(254, 'Email must be 6 to 254 characters long')
